import api from '../../../api/_consommable'

export default {
    getConsommables() {
        return new Promise((resolve, reject) => {
            api.consommables().then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeConsommables() {
        return new Promise((resolve, reject) => {
            api.getListeConsommables().then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
}